import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Image, ImageProps } from 'expo-image';
import
  Animated,
  {
    Easing,
    EasingFunction,
    EasingFunctionFactory,
    useAnimatedStyle,
    useSharedValue,
    withRepeat,
    withSpring,
    withTiming,
    WithTimingConfig
  } from 'react-native-reanimated';

const styles = StyleSheet.create({
  container: {
  },
  containerDebug: {
    borderWidth: 1,
    borderColor: "red",
  },
  animatedView: {
  },
  animatedViewDebug: {
    borderWidth: 1,
    borderColor: "green",
  },
});

export enum Animation {
  UpAndDownTiming,
};

export type AnimatedImageProps = {
  animation: Animation,
  width: number,
  height: number,
  range?: number,
  debug?: boolean,
} & WithTimingConfig & ImageProps;

export function AnimatedImage({
  animation,
  width,
  height,
  debug = false,
  duration = 2000,
  range = 20,
  easing = Easing.linear,
  ...imageProps
}: AnimatedImageProps) : React.ReactNode {
  const translate = useSharedValue<number>(0);

  const animatedStyles = useAnimatedStyle(() => ({
    transform: [
      {
        translateY: translate.value,
      },
      //{
      //  translateX: translate.value,
      //},
    ],
  }));

  React.useEffect(() => {
    if (animation == Animation.UpAndDownTiming) {
      // https://docs.swmansion.com/react-native-reanimated/docs/fundamentals/customizing-animation#configuring-withtiming
      translate.value = withRepeat(
        withTiming(
          range,
          {
            duration: duration,
            easing: easing,
          }
        ),
        -1,
        true,
      );
    }
  }, [animation, range, duration, easing]);

  return (
    <View style={ !debug ? styles.container : styles.containerDebug }>
      <Animated.View
        style={[
          !debug ? styles.animatedView : styles.animatedViewDebug,
          {
            width: width,
            height: height,
          },
          animatedStyles,
        ]}
      >
        <Image {...imageProps} />
      </Animated.View>
    </View>
  );
};
